module.exports = __webpack_public_path__ + "static/media/bg-desk-spacer.3823cdd4.svg";